<div class="container">
  <app-header *ngIf="store.option_layout.header()"></app-header>
  <main
    class="mx-auto w-11/12"
    [ngClass]="{
      'lg:w-8/12 md:w-10/12': store.option_layout.sizeXL(),
      'lg:w-6/12 md:w-8/12': !store.option_layout.sizeXL(),
      'md:flex md:flex-col md:justify-center': store.option_layout.vertical_align()
    }">
    <app-resume-step *ngIf="store.option_layout.resume_step()"></app-resume-step>
    <app-breadcrumb *ngIf="store.option_layout.breadcrumb()"></app-breadcrumb>
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
  <app-web-callback *ngIf="store.option_layout.webcallback()"></app-web-callback>
</div>
